module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero.79cc1c7f.png";